$(document).on('turbolinks:load', function () {
  initCharCounters();
})

$(document).on('input focus blur', "textarea", function (e) {
  countChars(this);
});

window.countChars = function (input) {
  let max = parseInt($(input).attr('data-char-max'));
  let min = parseInt($(input).attr('data-char-min'));

  const minHtml = min > -1 ? `<span class="char-counter-wrapper__min">[min: ${min}]</span>` : ''

  if (min || max) {
    let current = $(input).val().length;

    if ($(`.char-counter-${input.id}`).length == 0) {
      $(input).after(`<div class="char-counter-wrapper"><span class='char-counter char-counter-${input.id}'></span></div>`);
    }

    if (min && !max) {
      let percentage = (min - current).toFixed(3);
      $(`.char-counter-${input.id}`).css('color', counterColor(percentage));
      $(`.char-counter-${input.id}`).text(`${min}/${current}`);
      return
    }

    if (!min && max) {
      let percentage = (current / max).toFixed(3);
      $(`.char-counter-${input.id}`).css('color', counterColor(percentage));
      $(`.char-counter-${input.id}`).text(`${current}/${max}`);
      return
    }

    if (min && max) {
      if (current < min) {
        let percentage = (min - current).toFixed(3);
        $(`.char-counter-${input.id}`).css('color', counterColor(percentage));
        $(`.char-counter-${input.id}`).text(`${min}/${current}/${max}`);
      } else {
        let percentage = (current / max).toFixed(3);
        $(`.char-counter-${input.id}`).css('color', counterColor(percentage));
        $(`.char-counter-${input.id}`).text(`${min}/${current}/${max}`);
      }
      return
    }
  }
}

window.initCharCounters = function (input) {
  $('textarea').each(function () {
    countChars(this);
  })
}

window.counterColor = function (ratio) {
  if (ratio > 1) {
    return '#b71c1c';
  }
  if (ratio < 0.9) {
    return 'initial';
  }
  return '#f57f17';
}

//USAGE
/*
<%= f.text_field :some_limited_input, data: { char_max: 80 } %>
*/
